/**
 * Definition of supplier constants
 *
 * File for centralized management of supplier-related constants
 */

/**
 * Types of suppliers
 */
export enum SupplierType {
  HIVESTACK = 'hivestack',
  // Add future suppliers here
}

/**
 * Display names for suppliers
 */
export const SUPPLIER_DISPLAY_NAMES: Record<SupplierType, string> = {
  [SupplierType.HIVESTACK]: 'Hivestack',
  // Add future suppliers here
};

/**
 * Default supplier
 */
export const DEFAULT_SUPPLIER = SupplierType.HIVESTACK;

/**
 * List of all available suppliers
 */
export const ALL_SUPPLIERS = Object.values(SupplierType);

/**
 * Get the display name for a supplier
 * @param supplier Type of supplier
 * @returns Display name for the supplier
 */
export function getSupplierDisplayName(supplier: SupplierType): string {
  return SUPPLIER_DISPLAY_NAMES[supplier] || supplier;
}
